import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MasterService } from "src/app/services/master.service";
import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-modal",
  templateUrl: "./imgViewerModal.component.html",
  styleUrls: ["./imgViewerModal.component.scss"],
})
export class ImageViewerModalComponent implements OnInit {
  base64: string;
  pdfSrc: any;
  documentName: string;
  fileName: string;
  @Input() imageData: string | SafeResourceUrl;
  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    const byteArray = new Uint8Array(
      atob(this.base64)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: "image/jpeg/jpg/png" });
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(blob)
    );
  }

  // async downloadPdf() {
  //   let platform = localStorage.getItem("platform");
  //   if (platform == "android" || platform == "ios") {
  //     try {
  //       let ret = await Filesystem.mkdir({
  //         path: "ihlms",
  //         directory: Directory.Documents,
  //         recursive: false,
  //       });
  //       console.log("folder ", ret);
  //     } catch (e) {
  //       console.log("Folder already exists");
  //     }

  //     await Filesystem.writeFile({
  //       path: "ihlms/" + this.fileName,
  //       data: "data:application/pdf;base64," + this.base64,
  //       directory: Directory.Documents,
  //     });

  //     const toast = await this.toastController.create({
  //       message: this.fileName + " Downloaded in Documents folder",
  //       icon: "information-circle",
  //       position: "top",
  //       cssClass: "toast success-toast",
  //       duration: 2000,
  //     });
  //     toast.present();
  //   } else {
  //     window.open(this.pdfSrc, "_blank");
  //   }
  // }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
